// import
import Dashboard from "views/Dashboard/Dashboard";
import Veilles from "views/Dashboard/Veilles";
import VeilleDetail from "views/Dashboard/VeilleDetail";
import NouvelleVeille from "views/Dashboard/NouvelleVeille";
import Statistiques from "views/Dashboard/Statistiques";
import Alertes from "views/Dashboard/Alertes";
import Equipe from "views/Dashboard/Equipe";
import MonEspace from "views/Dashboard/MonEspace";
import Administration from "views/Dashboard/Administration";
import CollecteMatrice from "views/Dashboard/CollecteMatrice";
import Utilisation from "views/Dashboard/Utilisation";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";
import ResetPassword from "views/Auth/ResetPassword.js";
import { Icon } from "@chakra-ui/react";
import { FaUserShield, FaExclamationTriangle, FaPlus, FaClipboardList } from "react-icons/fa";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
} from "components/Icons/Icons";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Tableau de bord",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/veilles/:id",
    name: "Détail de la veille",
    hidden: true,
    icon: <StatsIcon color="inherit" />,
    component: VeilleDetail,
    layout: "/admin",
  },
  {
    path: "/veilles",
    name: "Mes veilles",
    rtlName: "لوحة القيادة",
    icon: <DocumentIcon color="inherit" />,
    component: Veilles,
    layout: "/admin",
  },
  {
    path: "/nouvelle-veille",
    name: "Nouvelle veille",
    rtlName: "لوحة القيادة",
    icon: <Icon as={FaPlus} color="inherit" />,
    component: NouvelleVeille,
    layout: "/admin",
  },
  {
    path: "/statistiques",
    name: "Statistiques",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: Statistiques,
    layout: "/admin",
  },
  {
    path: "/alertes",
    name: "Alertes flash",
    rtlName: "لوحة القيادة",
    icon: <Icon as={FaExclamationTriangle} color="inherit" />,
    component: Alertes,
    layout: "/admin",
  },
  {
    path: "/administration",
    name: "Administration",
    rtlName: "لوحة القيادة",
    icon: <Icon as={FaUserShield} color="inherit" />,
    component: Administration,
    layout: "/admin",
    admin: true,
  },
  {
    path: "/collecte-matrice",
    name: "Collecte matrice",
    rtlName: "لوحة القيادة",
    icon: <Icon as={FaClipboardList} color="inherit" />,
    component: CollecteMatrice,
    layout: "/admin",
    superAdmin: true,
  },
  {
    name: "COMPTE",
    category: "account",
    rtlName: "صفحات",
    state: "pageCollapse",
    views: [
      {
        path: "/utilisation",
        name: "Utilisation",
        rtlName: "لوحة القيادة",
        icon: <CreditIcon color="inherit" />,
        component: Utilisation,
        layout: "/admin",
        admin: true,
      },
      {
        path: "/equipe",
        name: "Équipe",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        component: Equipe,
        layout: "/admin",
        admin: true,
      },
      {
        path: "/mon-espace",
        name: "Mon espace",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        component: MonEspace,
        layout: "/admin",
        analyste: true,
      },
    ],
  },
  // Routes d'authentification — servies avant le dashboard, jamais affichées dans la sidebar
  {
    path: "/signin",
    name: "Connexion",
    icon: <DocumentIcon color="inherit" />,
    component: SignIn,
    layout: "/auth",
    hidden: true,
  },
  {
    path: "/signup",
    name: "Inscription",
    icon: <RocketIcon color="inherit" />,
    component: SignUp,
    layout: "/auth",
    hidden: true,
  },
  {
    path: "/reset",
    name: "Réinitialisation du mot de passe",
    icon: <DocumentIcon color="inherit" />,
    component: ResetPassword,
    layout: "/auth",
    hidden: true,
  },
];
export default dashRoutes;
